// extracted by mini-css-extract-plugin
module.exports = {"targetBlank":"style_targetBlank__b_3SQ"};